@if (highlightItem) {
  <app-highlight-teaser [highlight]="highlightItem"></app-highlight-teaser>
}

<app-category-navigation
  (categoryChanged)="onCategoryChanged($event)"
  [activeCategory]="activeEventType"
/>

<div class="flex flex-col justify-start mt-0 px-4 min-h-[400px]">
  @if (upcomingEvents.length > 0) {
    @for (event of upcomingEvents; track event.documentId) {
      <app-event-card
        class="mb-5"
        [title]="event.title"
        [location]="event | eventLocation"
        [dateText]="event | eventDate"
        [eventId]="event.documentId"
        [eventType]="event.type"
        [eventCategory]="event.category"
        [keywords]="event.keywords || []"
        [event]="event"
        [showLiveBadge]="isAnEventNow(event)"
      ></app-event-card>
    }
  } @else if (activeEventType !== "Alle") {
    <div class="text-center font-bold text-xl p-4">
      Oh... Hier scheint (noch) nichts los zu sein.
    </div>
    <div class="text-center p-4 text-gray-500">
      Lass uns das gemeinsam ändern. Schreibe deine Eventidee an
      <a href="mailto:intern@fourenergy.de">intern&#64;fourenergy.de</a>
    </div>
  }
</div>
